import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from './config';
import {ResourceStringProvider} from './resource/resourceStrings';
//Custom components
import {App} from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import ErrorFallback from './components/common/ErrorFallback';
import './index.css';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import 'ag-grid-enterprise';
import {LicenseManager} from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(import.meta.env.VITE_AGGRID_KEY);

if (import.meta.env.VITE_ENABLE_LOGROCKET === 'true') {
    LogRocket.init(import.meta.env.VITE_ENABLE_LOGROCKET_APPID);

    setupLogRocketReact(LogRocket);
}

// Set page title from environment variable
if (import.meta.env.VITE_PAGE_TITLE) {
    document.title = import.meta.env.VITE_PAGE_TITLE;
}

ReactDOM.render(
    <ErrorBoundary
        fallback={(error, errorInfo, reset) => (
            <ErrorFallback
                error={error}
                errorInfo={errorInfo}
                onReset={reset}
            />
        )}>
        <BrowserRouter>
            <ConfigProvider>
                <ResourceStringProvider>
                    <App></App>
                </ResourceStringProvider>
            </ConfigProvider>
        </BrowserRouter>
    </ErrorBoundary>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
